




















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import creditServices from '@/services/credit-services';
import { eventBus } from '@/main';
const numeral = require('numeral');
@Component({
    components: {
        Loading
    }
})
export default class Recharge extends Vue {
  @Prop({ default: null })
  private onRecharge!: boolean;

  private isLoading = false;
  private rechargeModel = {
    rechargeValue: 0,
    bankId: 3,
    tradeContent: '',
    bankNumber: '',
    bankAccount: '',
    bankName: '',
    qrCode: ''
  };
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
  get rechargeMethods() {
    return DATA.rechargeMethods;
  }
  @Watch('onRecharge', { immediate: true, deep: true })
  private watchOnRecharge() {
    this.recharge();
  }

  private async recharge() {
    try {
      const isValid = await (this.$refs['observer'] as any).validate();
      if (isValid) {

        this.isLoading = true;

        const bankInfo = this.rechargeMethods.find((p) => {return p.value === this.rechargeModel.bankId});

        const dataRequest = {
          Amount: numeral(this.rechargeModel.rechargeValue).value(),
          Method: this.rechargeModel.bankId,
          UID: this.userInfo.userId,
          Username: this.userInfo.userName,
          TradeContent: `NAP ${this.userInfo.userName}`
        };

        const result = await creditServices.submitRecharge(dataRequest);

        if (
          result &&
          result.status === 200 &&
          result.data.message === 'Success'
        ) {
          Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thành công!',
          });
          const qrCode = `https://img.vietqr.io/image/${bankInfo.name}-${bankInfo.acc_number}-compact2.jpg?amount=${numeral(this.rechargeModel.rechargeValue).value()}&addInfo=NAP%20${this.userInfo.userName}&accountName=${bankInfo.acc_name}`;
          this.rechargeModel = {
            rechargeValue: 0,
            bankId: 0,
            tradeContent: '',
            bankNumber: '',
            bankAccount: '',
            bankName: '',
            qrCode
          };
          eventBus.$emit(APP_CONFIG.eventBusAction.reloadWithdrawalHistories);
        } else if (result && result.data.status === 202) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: result.data.error,
            });
            this.isLoading = false;
        } else {
          Vue.notify({
            group: 'foo',
            type: 'error',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thất bại!',
          });
        }
        
        this.isLoading = false;
      }
    } catch {
      return false;
    }
  }
}
